export const hourTypeOptions: any = [
  { value: 'regular', label: 'Regular Work' },
  { value: 'no-hours-worked', label: 'No Hours Worked' },
  { value: 'sick-day', label: 'Sick Day' },
  { value: 'other', label: 'Other' },
  
];
